var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',{staticClass:"pa-0",style:(`height: ${_vm.height}px; overflow: auto`)},[_c('a-table-f-api',{ref:"table",attrs:{"api":_vm.m.api,"model":_vm.model,"searchable":false,"defaults":{
        filters: { lead_id: _vm.id },
        sort: { key: 'id', order: 'DESC' },
        paramName: 'leadActions',
      }},on:{"click":function($event){return _vm.onClickRow($event)}},scopedSlots:_vm._u([{key:"item.type",fn:function({ row }){return [(row.data && row.data.link)?_c('a-view-table-record',{attrs:{"model":{ direct: true },"value":row.data.link}}):_vm._e()]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }